<template>
  <div class="tour-conditions">
    <div v-if="included.length" class="tour-conditions__item">
      <div class="tour-conditions__title font-semibold">{{$t("serpDetail.included")}}</div>
      <extension-cropped
        v-if="includedExtended"
        :label-extended="$t('dropdownTrigger.default.extended')"
        :label-shrunk="$t('dropdownTrigger.default.shrunk')"
      >
        <list-markered :items="included">
          <template #marker>
            <svg-inline>
              <icon icon="checkmark" />
            </svg-inline>
          </template>
        </list-markered>
      </extension-cropped>
      <list-markered v-else :items="included">
        <template #marker>
          <svg-inline>
            <icon icon="checkmark" />
          </svg-inline>
        </template>
      </list-markered>
    </div>
    <div v-if="notIncluded.length" class="tour-conditions__item">
      <div class="tour-conditions__title font-semibold">{{$t("serpDetail.notIncluded")}}</div>
      <extension-cropped
        v-if="notIncludedExtended"
        :label-extended="$t('dropdownTrigger.default.extended')"
        :label-shrunk="$t('dropdownTrigger.default.shrunk')"
      >
        <list-markered :items="notIncluded">
          <template #marker>
            <div class="tour-conditions__icon-cross u-text-red">
              <svg-inline>
                <icon icon="close" />
              </svg-inline>
            </div>
          </template>
        </list-markered>
      </extension-cropped>
      <list-markered v-else :items="notIncluded">
        <template #marker>
          <div class="tour-conditions__icon-cross u-text-red">
            <svg-inline>
              <icon icon="close" />
            </svg-inline>
          </div>
        </template>
      </list-markered>
    </div>
  </div>
</template>

<script>
import ExtensionCropped from "@/components/ui-kit/extension-cropped/index.vue";
import ListMarkered from "@/components/ui-kit/list-markered/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

export default {
  components: {
    ExtensionCropped,
    ListMarkered,
    SvgInline,
    Icon,
  },
  props: {
    included: {
      type: Array,
      default() {
        return [];
      },
    },
    notIncluded: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    includedExtended() {
      return this.included.length > 3;
    },
    notIncludedExtended() {
      return this.notIncluded.length > 3;
    },
  },
};
</script>

<style lang="scss" scoped>
.tour-conditions {
  &__item {
    padding: 24px 0;
    border-top: 1px solid var.$gray-light;
  }

  &__title {
    margin-bottom: 16px;
  }

  &__icon {
    &-cross {
      padding: 3px;
    }
  }
}
</style>
